import { FC } from 'react';
import { Button, ControlUnit } from '@features/ui';
import { useTranslation } from 'react-i18next';
import { ExternalLinkIcon } from '@features/ui/icons';
import { TPlatformDownload } from '@src/types';

interface PlatformCardProps {
  item: TPlatformDownload;
  onDownload?: () => void;
}
export const PlatformCard: FC<PlatformCardProps> = ({ item, onDownload }) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        'flex flex-col items-center bg-[#262A30] rounded-[6px] border-1 border-[#CECECE] px-4.5 py-5.5 h-[165px] min-w-[408px] max-lg:w-full gap-y-2'
      }
    >
      <div className={'flex w-full justify-between items-center'}>
        <ControlUnit
          active
          className={'text-xs w-fit text-[#14CA74] px-[6px]'}
          value={t('downloads.free')}
        />
        <Button
          className="[&_svg]:!size-auto hover:text-white"
          size={'xs'}
          variant={'ghost'}
          onClick={onDownload}
        >
          <ExternalLinkIcon />
        </Button>
      </div>
      <img
        alt={'platform'}
        height={item.height}
        src={item.src}
        width={item.width}
      />
    </div>
  );
};
